export default __webpack_public_path__ + "static/media/Gerald&Eric2.4c6ba8f9.jpg";